import { createSlice } from '@reduxjs/toolkit'
import { currentDate,earlierDate } from '../../services/Util';
var startDate = currentDate();
startDate = earlierDate(startDate,1,"months");
var endDate = currentDate();
var newDateRange = [startDate?._d,endDate._d]

export const MonthFilterDropdown = createSlice(
{

  name: 'select_month',
  initialState: {
    value: newDateRange,
  },
  reducers: {
    monthSelected: (state, action) => {
      state.value = action.payload
    },
  },
}
)

export const { monthSelected } = MonthFilterDropdown.actions

export default MonthFilterDropdown.reducer